<template>
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header">
                    <div class="card-title">Média departamentos</div>
                </div>
                <div class="card-body">
                    <horizontal-bar
                        v-if="sectorsData.datasets.length"
                        :chart-data="sectorsData"
                        :styles="responseFrequencyStyle"
                        :options="chartOptions.responseFrequency"
                    ></horizontal-bar>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HorizontalBar from "../Charts/HorizontalBar.js";
export default {
    data() {
        return {
            sectors: [],
            anonymous_sector: {
                id: 999,
                name: 'Anônimo'
            },
            mainColors: [
                "#55efc4", //Green
                "#a29bfe", //Purple
                "#ffeaa7", //Yellow
                "#ff7675", //Red
                "#74b9ff",
                "#f0b0a0"
            ],
            colors: {
                0: "#ff0000", //Red
                1: "#FD8804", //Green
                2: "#D3D000", //Purple
                3: "#7EBD0C", //Yellow
                4: "#42C516" //Red
            },
            chartOptions: {
                responseFrequency: {
                    responsive: true,
                    maintainAspectRatio: false,
                    tooltips: {
                        enabled: true,
                        callbacks: {
                            label: function(tooltipItem, data) {
                            var allData = data.datasets[tooltipItem.datasetIndex].data;
                            var tooltipLabel = data.labels[tooltipItem.index];
                            var tooltipData = allData[tooltipItem.index];
                            return tooltipLabel + ": " + tooltipData + "%";
                            }
                        }                       
                    },
                    hover: {
                        animationDuration: 30
                    },
                    scales: {
                        xAxes: [
                            {
                                ticks: {
                                    beginAtZero: true,
                                    fontFamily: "'Open Sans Bold', sans-serif",
                                    fontSize: 11,
                                    max: 100,
                                    callback: function(value, index, values) {
                                    return value + '%';
                                    }
                                },
                                scaleLabel: {
                                    display: false,
                                },
                                gridLines: {},
                                stacked: true
                            }
                        ],
                        yAxes: [
                            {
                                gridLines: {
                                    display: false,
                                    color: "red",
                                    zeroLineColor: "red",
                                    zeroLineWidth: 0
                                },
                                ticks: {
                                    fontFamily: "'Open Sans Bold', sans-serif",
                                    fontSize: 13,
                                    fontStyle: "bold"
                                },
                                stacked: true
                            }
                        ]
                    },
                    legend: {
                        display: true,
                    },

                    pointLabelFontFamily: "Quadon Extra Bold",
                    scaleFontFamily: "Quadon Extra Bold"
                }
            }
        };
    },
    computed: {
        sectorsData() {
            const self = this;
            let labels = [];
            let datasets = [];
            self.sectors.forEach(sector => {
                labels.push(sector.name);
                labels.push("(Empresa)");
                labels.push("(Departamento)");
                labels.push("");
                let countersCompany = {
                    0: 0,
                    1: 0,
                    2: 0,
                    3: 0,
                    4: 0
                };
                let totalCounterCompany = 0;
                let counterPercentagesCompany = {
                    0: 0,
                    1: 0,
                    2: 0,
                    3: 0,
                    4: 0
                };
                let countersDepartment = {
                    0: 0,
                    1: 0,
                    2: 0,
                    3: 0,
                    4: 0
                };
                let totalCounterDepartment = 0;
                let counterPercentagesDepartment = {
                    0: 0,
                    1: 0,
                    2: 0,
                    3: 0,
                    4: 0
                };
                self.research.asks.forEach((ask, index) => {
                    if (ask.type_id == 1) {
                        ask.answer_scales.forEach(answer => {
                            if (
                                (
                                    answer.research_answer.user != null &&
                                    answer.research_answer.user.sector_id == sector.id
                                ) || 
                                (
                                    answer.research_answer.user == null && 
                                    sector.id == 999
                                )
                            ) {
                                totalCounterCompany++;
                                countersCompany[answer.company]++;
                            }
                        });
                        
                        ask.answer_scales.forEach(answer => {
                            if (
                                (
                                    answer.research_answer.user != null &&
                                    answer.research_answer.user.sector_id ==
                                    sector.id
                                ) || 
                                (
                                    answer.research_answer.user == null && 
                                    sector.id == 999
                                )
                            ) {
                                totalCounterDepartment++;
                                countersDepartment[answer.department]++;
                            }
                        });
                    }
                });
                for (let indexCounterCompany in countersCompany) {
                    //COMPANIES
                    counterPercentagesCompany[indexCounterCompany] =
                        (countersCompany[indexCounterCompany] * 100) /
                        totalCounterCompany;

                    if (!datasets[indexCounterCompany]) {
                        datasets.push({
                            data: [],
                            backgroundColor: self.convertHex(
                                self.colors[indexCounterCompany]
                                // 5
                            ),
                            // borderColor: self.convertHex(
                            //     self.colors[indexCounterCompany],
                            //     // 100
                            // ),
                            borderWidth: "2",
                            label: self.getScaleName(indexCounterCompany),
                            barThickness: 30
                        });
                    }
                    datasets[indexCounterCompany].data.push("");
                    datasets[indexCounterCompany].data.push(
                        counterPercentagesCompany[indexCounterCompany]
                            ? counterPercentagesCompany[
                                  indexCounterCompany
                              ].toFixed(2)
                            : ""
                    );

                    //SECTORS
                    counterPercentagesDepartment[indexCounterCompany] =
                        (countersDepartment[indexCounterCompany] * 100) /
                        totalCounterDepartment;

                    datasets[indexCounterCompany].data.push(
                        counterPercentagesDepartment[indexCounterCompany]
                            ? counterPercentagesDepartment[
                                  indexCounterCompany
                              ].toFixed(2)
                            : ""
                    );
                    datasets[indexCounterCompany].data.push("");
                }
            });

            return {
                labels: labels,

                datasets: datasets
            };
        },
        responseFrequencyStyle() {
            const self = this;

            return {
                height: `${self.sectors.length * 180 + 100}px`
            };
        }
    },
    methods: {
        getScaleName(value) {
            return value + " - " + this.research[`scale-label-${value}`];
        },
        convertHex(hex, opacity) {
            hex = hex.replace("#", "");
            const r = parseInt(hex.substring(0, 2), 16);
            const g = parseInt(hex.substring(2, 4), 16);
            const b = parseInt(hex.substring(4, 6), 16);

            const result =
                "rgba(" +
                r +
                "," +
                g +
                "," +
                b +
                (opacity ? "," + opacity / 100 : "") +
                ")";
            return result;
        },
        getSectors() {
            const self = this;
            const api = self.$store.state.api + "sectors";
            self.$http
                .get(api)
                .then(response => {
                    response.data.data.push(self.anonymous_sector);
                    self.sectors = response.data.data;
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        }
    },
    mounted: function() {
        this.getSectors();
    },
    components: {
        HorizontalBar
    },
    props: ["research"]
};
</script>


// WEBPACK FOOTER //
// src/components/Reusable/ScaleDepartmentChart.vue